import axios from 'axios'
import * as FileSaver from 'file-saver'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'
import { XML_TYPE } from 'Utilities'

const TEMPLATE_FILE_NAME = 'CampañasWhatsApp.xlsx'

export async function getCampaignWhatsAppRecipientsTemplate() {
    const { data: fileBuffer } = await axios.get(
        `${LEADS_ENDPOINT}/getCampaignWhatsAppRecipientsTemplate`,
        {
            method: 'GET',
            responseType: 'blob',
            timeout: 20000,
        }
    )

    const file = new Blob([fileBuffer], { type: XML_TYPE })
    FileSaver.saveAs(file, TEMPLATE_FILE_NAME)
}
